import { HIP } from '@eab-eip/hi-hip/hi-hif';
import { html } from 'lit-html';

import f1 from '@eab-pip/pi-f1';

function __renderVisitor(fieldType: Record<string, unknown>, builderEl: Element) {
  const inputVisitor = HIP.visitor.queryField(fieldType, 'dashboard');
  if (!inputVisitor) {
    return {};
  }

  const buildPanelEl = (inputVisitor as any).build(fieldType, builderEl);
  if (!buildPanelEl) {
    return {};
  }

  return buildPanelEl || {};
}

export const createPanelEl = (fieldType: Record<string, any>, builderEl: Element & { ns: string }) => {
  const hrf = !f1.is.empty(f1.read(f1.lens(`/report/render/panel`), {}, builderEl))
    ? f1.read(f1.lens(`/report/render/panel`), {}, builderEl)
    : f1.read(f1.lens(`/report/panel`), {}, builderEl);

  const panelTheme = f1.read(f1.lens(`/render/render_hints/color/value`), {}, hrf);

  return html` <vi-panel
    id="${fieldType.name}__panel"
    gid="${fieldType.name}__panel"
    .input=${hrf}
    region="${fieldType.name}"
    ns="${builderEl.ns}"
    allow-remove
  >
    <hi-tile aesthetic="dashboard" class="clr-${panelTheme}_30-bkg ns="${builderEl.ns}">
      <vi-panel-header ns="${builderEl.ns}">
        <div slot="title">
          <h3 class="clr-txt-gray_70">${fieldType.$configure.panel.panelHeader}</h3>
          <p class="clr-txt-gray_70">${fieldType.$configure.panel.panelSubHeader}</p>
        </div>
        <div slot="controls">
          <vi-panel-mover></vi-panel-mover>
        </div>
      </vi-panel-header>
      ${__renderVisitor(fieldType, builderEl)}
    </hi-tile>
  </vi-panel>`;
};
